import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui-primitives';
import { getLatestAppVersion } from '@repo/utils';
import { useGetApplication } from 'ze-sdk';
import { AlertLoading, DisplayError } from '../AlertContent';
export var RemoteVersionFlags = /*#__PURE__*/ function(RemoteVersionFlags) {
    RemoteVersionFlags["LATEST"] = "latest";
    RemoteVersionFlags["DEFAULT"] = "default";
    return RemoteVersionFlags;
}({});
export function RemoteVersionSelector(param) {
    let { organization, project, application, remoteVersion, mutateApplication } = param;
    var _appValue_versions, _appValue_versions1;
    var _getLatestAppVersion_dependencyVersion, _getLatestAppVersion;
    const { data, error, isLoading } = useGetApplication({
        organization,
        project,
        application
    });
    const appValue = data === null || data === void 0 ? void 0 : data.value;
    if (error) {
        return /*#__PURE__*/ _jsx(DisplayError, {
            error: error instanceof Error ? error : new Error('Failed to load application')
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ _jsx(AlertLoading, {
            isLoading: true
        });
    }
    if (!appValue) {
        return /*#__PURE__*/ _jsx("p", {
            className: "text-muted-foreground",
            children: "Application not found"
        });
    }
    const versions = (_appValue_versions = appValue.versions) !== null && _appValue_versions !== void 0 ? _appValue_versions : [];
    if (!versions.length) {
        return /*#__PURE__*/ _jsx("p", {
            className: "text-muted-foreground",
            children: "Application has no versions"
        });
    }
    remoteVersion = remoteVersion !== null && remoteVersion !== void 0 ? remoteVersion : (_getLatestAppVersion = getLatestAppVersion((_appValue_versions1 = appValue.versions) !== null && _appValue_versions1 !== void 0 ? _appValue_versions1 : [])) === null || _getLatestAppVersion === void 0 ? void 0 : (_getLatestAppVersion_dependencyVersion = _getLatestAppVersion.dependencyVersion) === null || _getLatestAppVersion_dependencyVersion === void 0 ? void 0 : _getLatestAppVersion_dependencyVersion.name;
    const handleVersionChange = ()=>{
        if (mutateApplication) {
            mutateApplication();
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full max-w-xs",
        children: /*#__PURE__*/ _jsxs(Select, {
            value: remoteVersion,
            disabled: false,
            onValueChange: ()=>{
                handleVersionChange();
            },
            children: [
                /*#__PURE__*/ _jsx(SelectTrigger, {
                    children: /*#__PURE__*/ _jsx(SelectValue, {
                        placeholder: "Select version"
                    })
                }),
                /*#__PURE__*/ _jsxs(SelectContent, {
                    children: [
                        /*#__PURE__*/ _jsx(SelectItem, {
                            value: "latest",
                            children: "Always use latest"
                        }),
                        versions.map((v)=>{
                            var _ref, _ref1;
                            var _v_dependencyVersion, _v_dependencyVersion1, _v_dependencyVersion2;
                            return /*#__PURE__*/ _jsx(SelectItem, {
                                value: (_ref = (_v_dependencyVersion = v.dependencyVersion) === null || _v_dependencyVersion === void 0 ? void 0 : _v_dependencyVersion.name) !== null && _ref !== void 0 ? _ref : '',
                                children: (_v_dependencyVersion1 = v.dependencyVersion) === null || _v_dependencyVersion1 === void 0 ? void 0 : _v_dependencyVersion1.name
                            }, (_ref1 = (_v_dependencyVersion2 = v.dependencyVersion) === null || _v_dependencyVersion2 === void 0 ? void 0 : _v_dependencyVersion2.name) !== null && _ref1 !== void 0 ? _ref1 : v.id);
                        })
                    ]
                })
            ]
        })
    });
}
